export default __webpack_public_path__ + "img/20.asset.d121a259.jpeg";